import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  carpalCure: {
    id: UpgradeType.CarpalCure,
    icon: ['cursor1', 'plus1'],
    cost: { gold: 4 },
    costGrowthRate: 2,
    multiplier: 0,
    purchased: 0,
    purchaseLimit: 1,
    bonusPerOwned: 0,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
    status: UpgradeStatus.Unlocked,
  },
  ironFinger: {
    id: UpgradeType.IronFinger,
    icon: ['silverBar', 'plus1'],
    cost: { gold: 30 },
    costGrowthRate: 2.0,
    multiplier: 1,
    purchased: 0,
    purchaseLimit: 40,
    bonusPerOwned: 5,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  featherFinger: {
    id: UpgradeType.FeatherFinger,
    icon: ['feather'],
    cost: { gold: 400 },
    costGrowthRate: 1.8,
    multiplier: 5, // 200ms
    purchased: 0,
    purchaseLimit: 5,
    bonusPerOwned: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  perfectClick: {
    id: UpgradeType.PerfectClick,
    icon: ['cursor1', 'random'],
    cost: { gold: 190 },
    costGrowthRate: 2,
    multiplier: 0,
    purchased: 0,
    purchaseLimit: 10,
    bonusPerOwned: 5,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  criticalStrike: {
    id: UpgradeType.CriticalStrike,
    icon: ['s_cursor1', 'bang5'],
    cost: { gold: 750 },
    costGrowthRate: 3,
    multiplier: 2,
    purchased: 0,
    purchaseLimit: 10,
    bonusPerOwned: 10,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  wakeupCall: {
    id: UpgradeType.WakeupCall,
    icon: ['bell', 'minus1'],
    cost: { gold: 30000 },
    costGrowthRate: 1.2,
    purchased: 0,
    purchaseLimit: 10,
    multiplier: 0,
    bonusPerOwned: 0.1,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  goldenExplosion: {
    id: UpgradeType.GoldenExplosion,
    icon: ['h_bang2', 'bird'],
    cost: { gold: 700 },
    costGrowthRate: 1.5,
    purchased: 0,
    purchaseLimit: 20,
    multiplier: 1,
    bonusPerOwned: 0.25,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  naturalLeader: {
    id: UpgradeType.NaturalLeader,
    icon: ['d_r_star'],
    cost: { gold: 5000 },
    costGrowthRate: 1.5,
    purchased: 0,
    purchaseLimit: 20,
    multiplier: 0,
    bonusPerOwned: 0.001,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  moneyCursor: {
    id: UpgradeType.MoneyCursor,
    icon: ['coinStack2', 'arrowUp1'],
    cost: { gold: 1000 },
    costGrowthRate: 1.5,
    purchased: 0,
    purchaseLimit: 40,
    multiplier: 1,
    bonusPerOwned: 0.1,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
};
